import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAccountData } from '../redux/main/accountSlice';

/**
 * Componente per forzare i colori primari e secondari
 * Ignora completamente i colori dal database
 */
export function ForceColors() {
    const accountData = useSelector(selectAccountData);
    
    useEffect(() => {
        // Colori fissi: #383838 (grigio scuro) e #5a5a5a (grigio medio)
        const PRIMARY_RGB = '56, 56, 56';    // #383838
        const SECONDARY_RGB = '90, 90, 90';   // #5a5a5a
        
        // Applica i colori alle variabili CSS
        document.documentElement.style.setProperty('--primary', PRIMARY_RGB);
        document.documentElement.style.setProperty('--secondary', SECONDARY_RGB);
    }, [accountData]); // Riapplica i colori ogni volta che accountData cambia
    
    return null; // Questo componente non renderizza nulla
}
